import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmbroideredBrisbaneComponent } from './embroidered-workwear-brisbane.component';

const routes: Routes = [
  { path: '', component: EmbroideredBrisbaneComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmbroideredBrisbaneRoutingModule { }
